// extracted by mini-css-extract-plugin
module.exports = {"deposit-wrap":"Deposit_deposit-wrap__jPfxk","deposit-item":"Deposit_deposit-item__C8rIu"};